import ApiRequest from "../util/ApiRequest";
import GlobalData from "../util/GlobalData";

export default class PresenceForm {
    getProvinces = async () => {
        return await ApiRequest.set(`/v1/provinces`, "GET");
    }

    getCitiesByProvince = async (province) => {
        return await ApiRequest.set(`/v1/${province}/cities`, "GET");
    }
}
